/* Lavish Queen theme v2 */
(function () {
  'use strict';
  var LQ = window.LQ || { routes: {} };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (LQ.routes.root || '/').replace(/\/?$/, '/');

  function formatMoney(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- Dialogs (size guide, search) ---------- */
  function openDialog(d) { if (!d) return; if (d.showModal) d.showModal(); else d.setAttribute('open', ''); }
  function closeDialog(d) { if (!d) return; if (d.close) d.close(); else d.removeAttribute('open'); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-dialog]');
    if (o) { e.preventDefault(); openDialog(document.getElementById(o.getAttribute('data-open-dialog'))); }
    var c = e.target.closest('[data-close-dialog]');
    if (c) closeDialog(c.closest('dialog'));
    if (e.target.tagName === 'DIALOG') closeDialog(e.target); // click on backdrop
  });

  /* ---------- Predictive search ---------- */
  var searchDialog = $('#SearchDialog');
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-open-search]');
    if (s && searchDialog && searchDialog.showModal) {
      e.preventDefault(); openDialog(searchDialog);
      var i = $('[data-predictive-input]', searchDialog); if (i) setTimeout(function () { i.focus(); }, 30);
    }
  });
  if (searchDialog) {
    var input = $('[data-predictive-input]', searchDialog);
    var results = $('[data-predictive-results]', searchDialog);
    var hints = $('.lq-search-hints', searchDialog);
    var timer, ctrl;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; hints.hidden = false; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = (LQ.routes.search || '/search/suggest') + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,query&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.querySelector('.shopify-section') || doc.body;
          results.innerHTML = sec.innerHTML; hints.hidden = true;
        }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  function updateCounts(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    $$('[data-open-cart]').forEach(function (a) { a.setAttribute('aria-label', 'Shopping bag, ' + n + ' items'); });
  }
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var p = $('.lq-drawer-panel', drawer); if (p) p.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function renderDrawer(html) {
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer]');
    if (!fresh) return;
    $('.lq-drawer-panel', drawer).innerHTML = $('.lq-drawer-panel', fresh).innerHTML;
    var src = $('[data-cart-count-source]', drawer); if (src) updateCounts(src.textContent.trim());
  }
  function refreshDrawer() {
    return fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (d) { renderDrawer(d['cart-drawer']); });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-cart]');
    if (o && drawer && LQ.drawer && !document.querySelector('[data-cart-page]')) { e.preventDefault(); refreshDrawer().then(openCart); }
    if (e.target.closest('[data-close-cart]')) closeCart();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  function changeLine(line, qty, scope) {
    var onPage = !!document.querySelector('[data-cart-page]') && scope !== 'drawer';
    if (drawer) drawer.classList.add('is-loading');
    return fetch((LQ.routes.cart_change || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (onPage) { window.location.reload(); return; }
      if (d.sections) renderDrawer(d.sections['cart-drawer']);
      if (typeof d.item_count !== 'undefined') updateCounts(d.item_count);
    }).finally(function () { if (drawer) drawer.classList.remove('is-loading'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]');
    var rm = e.target.closest('[data-line-remove]');
    var t = b || rm;
    if (!t) return;
    var li = t.closest('[data-line]'); if (!li) return;
    e.preventDefault();
    var scope = t.closest('[data-cart-drawer]') ? 'drawer' : 'page';
    changeLine(parseInt(li.getAttribute('data-line'), 10), rm ? 0 : Math.max(0, parseInt(b.getAttribute('data-line-qty'), 10)), scope);
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line-input]'); if (!i) return;
    var li = i.closest('[data-line]');
    changeLine(parseInt(li.getAttribute('data-line'), 10), Math.max(0, parseInt(i.value, 10) || 0), i.closest('[data-cart-drawer]') ? 'drawer' : 'page');
  });

  function addToCart(items) {
    return fetch((LQ.routes.cart_add || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer' })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]'); if (!q) return;
    e.preventDefault(); q.disabled = true;
    addToCart([{ id: parseInt(q.getAttribute('data-quick-add'), 10), quantity: 1 }]).then(function (d) {
      if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
      if (d.sections) renderDrawer(d.sections['cart-drawer']);
    }).catch(function () { q.disabled = false; });
  });

  /* ---------- Product page ---------- */
  var productRoot = $('[data-product-root]');
  if (productRoot) {
    var product = JSON.parse(($('[data-product-json]') || {}).textContent || '{}');
    var form = $('[data-product-form]', productRoot);
    var idInput = form && $('[data-variant-id]', form);
    var atc = form && $('[data-atc]', form);
    var atcLabel = form && $('[data-atc-label]', form);
    var errorEl = form && $('[data-form-error]', form);
    var fieldsets = form ? $$('.lq-option', form) : [];

    var track = $('[data-gallery-track]', productRoot);
    var thumbs = $$('[data-thumb]', productRoot);
    var idxEl = $('[data-gallery-index]', productRoot);
    function goTo(i) {
      if (!track) return;
      var slide = track.children[i]; if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
          if (idxEl) idxEl.textContent = i + 1;
        });
      });
    }

    function selectedOptions() {
      return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function findVariant(opts) {
      return (product.variants || []).filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, idx) {
        $$('.lq-swatch', fs).forEach(function (sw) {
          var input = $('input', sw);
          var match = (product.variants || []).some(function (v) {
            return v.available && v.options.every(function (o, i) { if (i === idx) return o === input.value; if (i < idx) return o === opts[i]; return true; });
          });
          sw.classList.toggle('is-unavailable', !match);
        });
      });
    }
    function updateVariant() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) { var l = $('[data-option-label]', fs); if (l) l.textContent = opts[i] || ''; });
      markAvailability(opts);
      var v = findVariant(opts);
      if (errorEl) errorEl.hidden = true;
      if (!v) {
        atc.disabled = true; atcLabel.textContent = 'UNAVAILABLE'; return;
      }
      idInput.value = v.id;
      var price = $('[data-price]', productRoot), cmp = $('[data-compare]', productRoot), save = $('[data-save]', productRoot);
      if (price) price.textContent = formatMoney(v.price);
      var mp = $('[data-mobile-price]'); if (mp) mp.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = formatMoney(v.compare_at_price); }
      if (save) { save.hidden = !onSale; if (onSale) save.textContent = 'Save ' + formatMoney(v.compare_at_price - v.price).replace(/\.00$/, ''); }
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? 'ADD TO BAG · ' + formatMoney(v.price) : 'SOLD OUT';
      if (v.featured_media && track) {
        var target = track.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (target) goTo(Array.prototype.indexOf.call(track.children, target));
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('lavish:variant-change', { detail: { variant: v } }));
    }
    if (fieldsets.length) {
      form.addEventListener('change', function (e) { if (e.target.name && e.target.name.indexOf('option-') === 0) updateVariant(); });
      markAvailability(selectedOptions());
    }

    $$('[data-qty-step]', productRoot).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = $('[data-qty-input]', productRoot);
        i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
      });
    });

    if (form && LQ.drawer && drawer) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qty = parseInt(($('[data-qty-input]', form) || {}).value, 10) || 1;
        var original = atcLabel.textContent;
        atc.disabled = true; atcLabel.textContent = 'ADDING…';
        addToCart([{ id: parseInt(idInput.value, 10), quantity: qty }]).then(function (d) {
          if (d.sections) renderDrawer(d.sections['cart-drawer']);
          openCart();
          if (typeof fbq === 'function') { try { fbq('track', 'AddToCart'); } catch (x) {} }
        }).catch(function (err) {
          if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; errorEl.hidden = false; }
        }).finally(function () { atc.disabled = false; atcLabel.textContent = original; });
      });
    }

    var mobileBuy = $('[data-mobile-buy]');
    if (mobileBuy && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        mobileBuy.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(atc);
    }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-scroll-to-product]')) {
      var f = document.querySelector('[data-product-form]');
      if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---------- Product recommendations ---------- */
  var recs = $('[data-recommendations]');
  if (recs && recs.getAttribute('data-url')) {
    var load = function () {
      fetch(recs.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) recs.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(recs);
    } else load();
  }

  /* ---------- Header dropdowns: close others / on outside click ---------- */
  document.addEventListener('click', function (e) {
    $$('.nav-dd[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  $$('.nav-dd').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) $$('.nav-dd[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); }); });
  });
})();
